import Vue from "vue";
import Vuetify from "vuetify/lib";
import CustomIcon from '@/plugins/customIcon.vue'
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00AAE7',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#FF604A',
                success: '#15C26B'
            },
        },
    },
    icons: {
        values: {
            custom: { // name of our custom icon
                component: CustomIcon, // our custom component
            },
        },
    },
});
